import { useEffect, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../redux/AppStore";
import { updateShipmentCity } from "../../redux/slice/UpdateTrackingAddressSlice";

export default function ShipmentCityComponent() {
  const dispatch = useAppDispatch();
 const customerCity:string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_customer_city);

    return (
        <div className="UpdateVerifyInput">
        <label>City</label>
        <input type="text" className="form-control" placeholder="Your City" value={customerCity} onChange={t => 
          {
            dispatch(
                updateShipmentCity(t.target.value)
            )
         }
            }/>
      </div>
    );
}